<template>
    <form @submit.prevent="submit" @keydown="errors.clear($event.target.name)">

        <base-input class="mb-3"
            :label="$t('common.name')"
            :placeholder="$t('common.name')"
            required
            v-model="value.name"
            name="name"
            :error="errors.get('name')">
        </base-input>

        <base-input class="mb-3"
            :label="$t('common.username')"
            :placeholder="$t('common.username')"
            required
            v-model="value.credentials.username"
            name="username"
            :error="errors.get('username')">
        </base-input>

        <base-input class="mb-3"
            :label="$t('common.password')"
            :placeholder="$t('common.password')"
            required
            v-model="value.credentials.password"
            name="password"
            :error="errors.get('password')">
        </base-input>

        <base-input class="mb-3"
            :label="$t('accesses.cors')"
            :placeholder="$t('accesses.cors')"
            v-model="value.cors"
            name="cors"
            :error="errors.get('cors')">
        </base-input>

        <base-checkbox class="mb-3" v-model="value.active">
            {{ $t('common.active') }}
        </base-checkbox>
        
        <base-checkbox class="mb-3" v-model="value.inherited_permissions">
            {{ $t('accesses.adopt-client-permissions') }}
        </base-checkbox>
        
        <div class="mt-4 mb-4" v-if="!value.admin && permissions['xapi-scopes'] !== undefined && !value.inherited_permissions">
            <h4 class="card-title mb-2">{{ $t('xapi.common.authorization-scopes') }}</h4>
            <base-checkbox v-for="(permission, key) in permissions['xapi-scopes'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
        </div>

        <div class="mt-4 mb-4" v-if="!value.admin && !value.inherited_permissions">
            <h4 class="card-title mb-2">{{ $t('xapi.common.extra-permissions') }}</h4>
            <base-checkbox v-for="(permission, key) in permissions['xapi-extra'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
            <base-checkbox v-for="(permission, key) in permissions['cmi5'].permissions" :key="key"
                v-model="value.permissions[key]">

                {{ permission.name }}
            </base-checkbox>
        </div>

        <div class="category form-category mb-3">* {{ $t('common.required-fields') }}</div>

        <div class="buttons pt-2 text-center">
            <base-button type="primary" native-type="submit" :disabled="errors.any()">
                {{ value.id ? $t('common.update') : $t('common.create') }}
            </base-button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t('common.cancel') }}
            </button>
        </div>

    </form>
</template>

<script>
    export default {
        props: ['value', 'errors', 'permissions'],
        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
